import BootstrapBreakpoint from "./bootstrap-breakpoint";
import DisallowSpaces from "./disallow-spaces";
import DragHandles from "./drag-handles";
import IllegalChars from "./illegal-chars";
import InputIsEmpty from "./input-is-empty";

const modul = angular
    .module("features", [])

    .directive("bootstrapBreakpoint", BootstrapBreakpoint)
    .directive("disallowSpaces", DisallowSpaces)
    .directive("dragHandles", DragHandles)
    .directive("illegalChars", IllegalChars)
    .directive("inputIsEmpty", InputIsEmpty);
export default modul.name;
